import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-[0_1px_0_oklch(var(--foreground-50)/0.06)]'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-2">
            <Link
              to="/"
              className="flex items-center gap-2 group"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-gradient-to-br from-primary-500 to-accent-500 rounded-lg">
                <i className="ri-movie-2-fill text-lg" style={{ color: 'oklch(var(--background-50))' }}></i>
              </div>
              <span className="text-lg font-bold font-heading whitespace-nowrap" style={{ color: 'oklch(var(--foreground-950))' }}>
                黄瓜影视
              </span>
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-500/15 text-primary-600'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-foreground-50/5'
              }`}
            >
              首页
            </Link>
            {categories.map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/15 text-primary-600'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-foreground-50/5'
                }`}
              >
                {cat.label}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-500/15 text-primary-600'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-foreground-50/5'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索你想看的影视..."
                className="w-56 h-9 pl-9 pr-3 rounded-full text-sm border-0 outline-none transition-all duration-200 focus:w-72"
                style={{
                  backgroundColor: 'oklch(var(--background-100))',
                  color: 'oklch(var(--foreground-800))',
                }}
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm" style={{ color: 'oklch(var(--foreground-400))' }}></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg"
            style={{ color: 'oklch(var(--foreground-800))' }}
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden border-t" style={{ borderColor: 'oklch(var(--foreground-50)/0.06)' }}>
          <div className="px-4 py-4 space-y-1">
            <Link to="/" className="block px-4 py-3 rounded-lg text-sm text-foreground-600 hover:text-foreground-950 hover:bg-foreground-50/5 transition-colors">首页</Link>
            {categories.map(cat => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="block px-4 py-3 rounded-lg text-sm text-foreground-600 hover:text-foreground-950 hover:bg-foreground-50/5 transition-colors">{cat.label}</Link>
            ))}
            <Link to="/about" className="block px-4 py-3 rounded-lg text-sm text-foreground-600 hover:text-foreground-950 hover:bg-foreground-50/5 transition-colors">关于我们</Link>
            <div className="relative mt-3 px-4">
              <input
                type="text"
                placeholder="搜索你想看的影视..."
                className="w-full h-9 pl-9 pr-3 rounded-full text-sm border-0 outline-none"
                style={{
                  backgroundColor: 'oklch(var(--background-100))',
                  color: 'oklch(var(--foreground-800))',
                }}
              />
              <i className="ri-search-line absolute left-7 top-1/2 -translate-y-1/2 text-sm" style={{ color: 'oklch(var(--foreground-400))' }}></i>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}